import { combineTokens } from '@utils/css';

const tokens = combineTokens("--stats", {
  correctPercentage: "0%"
});
const wrapper = "_35sw7cp0ih";
const label = "_35sl1fbvkba";
const statLine = "_35sslwatgj";
const statLineBar = "_35ssnib1tx";

export { label, statLine, statLineBar, tokens, wrapper };
import "./atom.stats.style.linaria.module.css";
//# sourceMappingURL=atom.stats.style.js.map
